import Http from '@/support/http';

import {
	compact
} from 'lodash';

import S from '@/support/string';

export default {
	getMessageRecipient(context, payload) {

		if (payload && payload.userId && payload.studentId) {

			return Http.get(`v1/messages/recipient?userId=${ payload.userId }&studentId=${ payload.studentId }`).then((response) => {

				response.data.forEach((value) => {

					if (!value.photoURL) {
						value.photoURL = 'assets/images/default-avatar.png';
					}

				});

				context.commit('SET_MESSAGE_RECIPIENT_LIST', response.data);

				return response;

			});

		}
	}, setMessageRecipientList(context, payload) {
		context.commit('SET_MESSAGE_RECIPIENT_LIST', payload);
	}, setSentInboxFilter(context, payload) {
		context.commit('SET_SENT_INBOX_FILTER', payload);
	}, setReceivedInboxFilter(context, payload) {
		context.commit('SET_RECEIVED_INBOX_FILTER', payload);
	}, setMessageRecipientResponsible(context, payload) {
		context.commit('SET_MESSAGE_RECIPIENT_RESPONSIBLE', payload);
	}, setMessageRecipientSchoolMembers(context, payload) {
		context.commit('SET_MESSAGE_RECIPIENT_SCHOOLMEMBERS', payload);
	}, getMessageRecipientIsResponsible(context, payload) {

		if (payload) {

			return compact(context.state.list.map((item) => {

				if (item.responsible) {
					return item;
				}

			}));

		} else {

			return compact(context.state.list.map((item) => {

				if (!item.responsible) {
					return item;
				}

			}));

		}

	}, getReceivedMessages(context, payload) {

		const queryString = S.makeQueryString(payload);

		return Http.get(`v1/messages/user/${ payload.data.id }/inbox${ queryString }`).then((response) => {

			context.commit('SET_MESSAGE_RECEIVED_LIST', response.data);

			return response;

		});

	}, getSentMessages(context, payload) {

		const queryString = S.makeQueryString(payload);

		return Http.get(`v1/messages/user/${ payload.data.id }/sent${ queryString }`).then((response) => {

			context.commit('SET_MESSAGE_SENT_LIST', response.data);

			return response;

		});

	}, getMessages(context, payload) {

		if (payload && payload.userId && payload.studentId) {

			const {
				userId,
				studentId
			} = payload;

			const route = `v1/messages/inbox/${ userId }/student/${ studentId }?page=0&quantity=5`;

			return Http.get(route).then((response) => {

				response.data.forEach((value) => {

					if (value.messages) {

						value.messages.forEach((aux) => {

							if (!aux.from.photoURL) {
								aux.from.photoURL = 'assets/images/default-avatar.png';
							}

						});

					}

				});

				context.commit('SET_MESSAGES_AGENDA_LIST', response.data);

				return response;

			});

		}

	}, putMessageResponsible(context, payload) {
		context.commit('PUT_MESSAGE_RESPONSIBLE', payload.target._value);
	}, putMessageRecipientSelected(context, payload) {
		context.commit('PUT_MESSAGE_RECIPIENT_SELECTED', payload.value);
	}, putMessageRecipients(context, payload) {

		if (payload) {

			const route = `v1/messages/${ payload.messageGroup }/user/${ payload.userId }/add-user/${ payload.newUserId }`;

			return Http.put(route).then((response) => {

				context.commit('SET_MESSAGE_GROUP', response.data);

				return response;

			});

		}

	}, putMessageSchoolMembers(context, payload) {
		context.commit('PUT_MESSAGE_SCHOOLMEMBERS', payload.value);
	}, putMessageSubject(context, payload) {
		context.commit('PUT_MESSAGE_SUBJECT', payload.value);
	}, putMessageMessage(context, payload) {
		context.commit('PUT_MESSAGE_MESSAGE', payload.value);
	}, getMessageGroup(context, payload) {

		if (context && context.getters.getLoggedUser.id) {

			return Http.get(`v1/messages/${ payload }/user/${ context.getters.getLoggedUser.id }`).then((response) => {

				response.data.messages = (response.data.messages).reverse();

				response.data.messages.forEach((aux) => {

					if (!aux.from.photoURL) {
						aux.from.photoURL = 'assets/images/default-avatar.png';
					}

				});

				context.commit('SET_MESSAGE_GROUP', response.data);

				return response;

			});

		}

	}, sendMessageChat(context, payload) {

		const route = `v1/messages/${ context.state.messageGroup.messageGroup }`;

		return Http.post(route, payload).then((response) => {
			return response;
		});

	}, sendMessageNew(context, payload) {

		const route = 'v1/messages';

		return Http.post(route, payload).then((response) => {
			return response;
		});

	}, putUnreadMessages(context, payload) {
		context.commit('PUT_UNREAD_MESSAGES', payload);
	}
};



// WEBPACK FOOTER //
// ./sources/app/inbox/actions.js